(function($, undefined) {

	/**
	 * Extension pro vyvolání souběžného AJAXového dotazu, např. pro překreslení stránky pod pdboxem.
	 */
	$.nette.pd.ext('onSuccessRequest', {
		success: function(payload, status, xhr, settings) {
			if ('nette' in settings && settings.nette.form) {
				$.nette.ajax({
					url: settings.nette.form.data('on-success-request-url'),
					off: ['abort', 'history', 'unique', 'pdbox']
				});
			}
		}
	});

})(jQuery);
